import { __rest } from "tslib";
import * as React from 'react';
import { st, classes } from './ColorPicker.deprecated.st.css';
import { ColorPickerBase } from './ColorPicker.base';
import { generateKey } from '../../common/random';
/** ColorPicker */
export class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this._groupName = generateKey('ColorPicker_group');
    }
    render() {
        const _a = this.props, { className, name } = _a, rest = __rest(_a, ["className", "name"]);
        return (React.createElement(ColorPickerBase, Object.assign({}, rest, { name: name || this.props['aria-label'] || this._groupName, className: st(classes.root, className) })));
    }
}
ColorPicker.displayName = 'ColorPicker';
ColorPicker.Item = ColorPickerBase.Item;
//# sourceMappingURL=ColorPicker.js.map